"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
/**
 * Форматирование даты в вид HH:mm
 * @param date - дата
 * @param valueIfNull - значение если дата пустая, по умолчанию '-'
 */
function formatTime(date, valueIfNull) {
    if (valueIfNull === void 0) { valueIfNull = '-'; }
    if (!date) {
        return valueIfNull;
    }
    else {
        return moment_1.default(date).format('HH:mm');
    }
}
exports.formatTime = formatTime;
/**
 * Форматирование даты в вид DD.MM.YYYY
 * @param date - дата
 * @param valueIfNull - значение если дата пустая, по умолчанию '-'
 */
function formatDate(date, valueIfNull) {
    if (valueIfNull === void 0) { valueIfNull = '-'; }
    if (!date) {
        return valueIfNull;
    }
    else {
        return moment_1.default(date).format('DD.MM.YYYY');
    }
}
exports.formatDate = formatDate;
/**
 * Форматирование даты в вид DD.MM.YYYY в HH:mm
 * @param date - дата
 * @param valueIfNull - значение если дата пустая, по умолчанию '-'
 */
function formatDateTime(date, valueIfNull) {
    if (valueIfNull === void 0) { valueIfNull = '-'; }
    if (!date) {
        return valueIfNull;
    }
    else {
        return moment_1.default(date).format('DD.MM.YYYY в HH:mm');
    }
}
exports.formatDateTime = formatDateTime;
function getIntervalTime(time, leftMinutes, rightMinutes, format, valueIfNull) {
    if (leftMinutes === void 0) { leftMinutes = 15; }
    if (rightMinutes === void 0) { rightMinutes = 15; }
    if (format === void 0) { format = '--:-- – --:--'; }
    if (valueIfNull === void 0) { valueIfNull = '-'; }
    if (time) {
        var first = moment_1.default(time, 'HH:mm');
        first.subtract(leftMinutes, 'minutes');
        var end = moment_1.default(time, 'HH:mm');
        end.add(rightMinutes, 'minutes');
        var firstStr = first.format('HH:mm');
        var endStr = end.format('HH:mm');
        switch (format) {
            case 'с --:-- до --:--': {
                return "\u0441 " + firstStr + " \u0434\u043E " + endStr;
            }
            case '--:-- – --:--': {
                return firstStr + " \u2013 " + endStr;
            }
            case '[--:--, --:--]': {
                return [firstStr, endStr];
            }
            default: {
                return valueIfNull;
            }
        }
    }
    else {
        return valueIfNull;
    }
}
exports.getIntervalTime = getIntervalTime;
//# sourceMappingURL=index.js.map